import { ArrowLeft, KeyRound } from 'lucide-react'
import { Link } from 'react-router-dom'

export function ResetPasswordPage() {
  return <main className="login-shell"><section className="login-panel" aria-labelledby="reset-title">
    <div className="brand-mark"><KeyRound /></div><p className="eyebrow">Acesso seguro</p><h1 id="reset-title">Redefinição administrativa</h1>
    <p className="supporting-copy">Solicite uma nova senha temporária ao administrador do sistema.</p>
    <Link className="login-back" to="/login"><ArrowLeft />Voltar ao login</Link>
  </section></main>
}
